/**
 * Extract numeric value from division name (e.g., "9U" -> 9, "10U" -> 10, "17U" -> 17)
 */
export function extractDivisionNumber(name: string): number {
  const match = name.match(/(\d+)/);
  return match ? parseInt(match[1], 10) : 999; // Put divisions without numbers at the end
}

/**
 * Sort divisions by their numeric value (9U, 10U, 11U, ... 17U)
 * Preserves all properties of the original objects
 */
export function sortDivisions<T extends { name: string }>(divisions: T[]): T[] {
  return divisions.slice().sort((a, b) => {
    const numA = extractDivisionNumber(a.name);
    const numB = extractDivisionNumber(b.name);
    return numA - numB;
  });
}
